export  const config={
    url:'https://api.floriskorea.com'
  // url:'https://test.floriskorea.com'
}
export const headersinfo={
    'Access-Control-Allow-Origin':'*',
    'Content-Type': `multipart/form-data`,
}
